export default {
  base: {
    back: 'retour',
    add: 'add',
    delete: 'supprimer'
  },
  title: {
    app: 'Vaquant',
    about: 'About',
    pricing: 'Pricing'
  },
  account: {
    create: 'Create an account',
    new: 'New account',
    setting: 'Setting: {name}',
    users: 'Users',
    danger_zone: 'Danger zone',
    delete: 'Delete account',
    main_currency: 'Main currency',
    use_currency: 'Use others currencies',
    used_currencies: 'Used currency | Used currencies',
    friends: 'Friend | Friends',
    amount_name: 'Name',
    payed_by: 'Payed by',
    none: 'No account currently'
  },
  about: {
    description: 'Vaquant is an app. Voilà!'
  },
  transaction: {
    weight: 'ratio | ratio | ratio'
  },
  user: {
    account: 'Account',
    loginsignup: 'Log in / Sign up',
    login: 'log in',
    signup: 'signup',
    password: 'password',
    confirm_password: 'confirm password',
    alias: 'Alias',
    email: 'Email',
    firstname: 'Firstname',
    lastname: 'Lastname',
    connectedwith: 'You are login with the email ',
    logout: 'log out',
    delete: 'delete profile'
  },
  validation: {
    max_char:
      'no character available | 1 character max | {max} character maximum'
  }
}
